import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="footer-logo-circle">
                <img src="/images/logo-gsu.png" alt="GSU Les Palmiers" />
              </div>
            </div>
            <p>
              Excellence académique et formation professionnelle de qualité. 
              Nous préparons nos élèves à devenir les leaders de demain.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" title="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="#" className="social-link" title="Twitter">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>
              <a href="#" className="social-link" title="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="#" className="social-link" title="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
                </svg>
              </a>
            </div>

            <div className="footer-contacts">
              <div className="footer-contact-item">
                <span className="contact-icon">📍</span>
                <span>Togba, Abomey-Calavi, Bénin</span>
              </div>
              <div className="footer-contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:+22997305230">+229 97 30 52 30</a>
              </div>
              <div className="footer-contact-item">
                <span className="contact-icon">✉️</span>
                <a href="mailto:contact@gsulespalmiers.bj">contact@gsulespalmiers.bj</a>
              </div>
              <div className="footer-contact-item">
                <span className="contact-icon">✉️</span>
                <a href="mailto:info@gsulespalmiers.bj">info@gsulespalmiers.bj</a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Navigation</h4>
            <ul>
              <li><button onClick={() => window.navigateTo && window.navigateTo('about')}>À propos</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('filieres')}>Nos Filières</button></li>
              {/* <li><button onClick={() => window.navigateTo && window.navigateTo('vie-scolaire')}>Vie Scolaire</button></li> */}
              <li><button onClick={() => window.navigateTo && window.navigateTo('actualites')}>Actualités</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('contact')}>Contact</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Informations</h4>
            <ul>
              <li><button onClick={() => window.navigateTo && window.navigateTo('documents-utiles')}>Fournitures & Horaires</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('student-registration')}>Admission</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('opportunites')}>Bourses d'études</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('opportunites')}>Stages</button></li>
              <li><button onClick={() => window.navigateTo && window.navigateTo('projets')}>Projets & Cagnottes</button></li>
            </ul>
          </div>

          <div className="footer-section footer-map-section">
            <h4>Localisation</h4>
            <div className="footer-map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.0!2d2.39!3d6.37!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNsKwMjInMTIuMCJOIDLCsDIzJzI0LjAiRQ!5e1!3m2!1sfr!2sbj!4v1234567890!5m2!1sfr!2sbj"
                width="100%"
                height="250"
                style={{ border: 0, borderRadius: '10px' }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation Lycée Les Palmiers"
              ></iframe>
              <a 
                href="https://www.google.com/maps/place/6%C2%B022'12.0%22N+2%C2%B023'24.0%22E/@6.37,2.39,17z/data=!3m1!4b1!4m4!3m3!8m2!3d6.37!4d2.39?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D&maptype=satellite" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="footer-map-link"
              >
                📍 Ouvrir dans Google Maps
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2025 GSU Les Palmiers - Tous droits réservés | Conçu par Atelier Canal Art</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
